import { makeAutoObservable, makeObservable, observable } from 'mobx';
import { LinkedMessengersStore } from './linked-messengers';
import { LinkedSocialsStrote } from './linked-socials/linked-socials.store';

export class ContactInfoStore {
    valid: boolean = false
    readonly linkedMessengers = new LinkedMessengersStore();
    readonly linkedSocials = new LinkedSocialsStrote();
    constructor() {
        makeObservable(this, {
            valid: observable
        })
    }
}
